<!--
 * Descripttion: 流程管理
 * version: 1.0
 * Author: lybbn
 * Email: 1042594286@qq.com
 * Program: django-vue-lyadmin 专业版
 * Website: http://doc.lybbn.cn
 * Date: 2024-06-30
 * LastEditDate: 2024-06-30
 * Remark: 此文件头信息头信息需保留！！！
-->
<template>
    <div :class="{'ly-is-full':isFull}">
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="流程名称：">
                    <el-input v-model.trim="formInline.name" maxlength="60"  clearable placeholder="流程名称" @change="search" style="width:160px"></el-input>
                </el-form-item>
                <el-form-item label=""><el-button  @click="search" type="primary" icon="Search" v-show="hasPermission(route.name,'Search')">查询</el-button></el-form-item>
                <el-form-item label=""><el-button  @click="handleEdit('','reset')" icon="Refresh">重置</el-button></el-form-item>
                <el-form-item label=""><el-button  @click="handleAddClick" type="primary" icon="Plus" v-show="hasPermission(route.name,'Create')">新建流程</el-button></el-form-item>
            </el-form>
        </div>
        <div class="table">
            <ly-table tableName="lyWorkflowManageTable" :height="tableHeight" :pageSize="10" :apiObj="$Api.lyworkflow" :params="formInline" ref="tableref" :column="column" showSequence>
                <template #version="scope">
                    <el-tag>{{ scope.row.version }}</el-tag>
                </template>
                <template #status="scope">
                    <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949" @change="changeStatus(scope.row)"></el-switch>
                </template>
                <el-table-column label="操作" fixed="right" width="180">
                    <template #header>
                        <div style="display: flex;justify-content: space-between;align-items: center;">
                            <div>操作</div>
                            <div @click="setFull">
                                <el-tooltip content="全屏" placement="bottom">
                                    <el-icon ><full-screen /></el-icon>
                                </el-tooltip>
                            </div>
                        </div>
                    </template>
                    <template #default="scope">
                        <span class="table-operate-btn" @click="handleEdit(scope.row,'edit')" v-show="hasPermission(route.name,'Update')">编辑</span>
                        <span class="table-operate-btn" @click="handleEdit(scope.row,'delete')" v-show="hasPermission(route.name,'Delete')">删除</span>
                    </template>
                </el-table-column>
            </ly-table>
        </div>
        <moduleWorkflow ref="moduleWorkflowFlag" @refreshData="getData" v-if="isWorkflowDialogVisible" @closed="isWorkflowDialogVisible = false"></moduleWorkflow>
    </div>
</template>
<script setup>
    import {nextTick,ref,onMounted,onUnmounted,getCurrentInstance} from "vue"
    import { ElMessage,ElMessageBox } from 'element-plus';
    import {dateFormats,getTableHeight} from "@/utils/util";
    import moduleWorkflow from "./components/moduleWorkflow.vue";
    import { useRoute } from 'vue-router'

    let Api = getCurrentInstance().appContext.config.globalProperties.$Api; // 声明$Api

    const isInitializing = ref(true)

    const route = useRoute()

    let tableData = ref([])
    let formInline = ref({})
    let loadingPage = ref(false)
    let tableHeight = ref(500)
    let tableSelect = ref(null)
    let column = ref([
        {
            label: "流程名称",
            prop: "name",
            minWidth:"130"
        },
        {
            label: "版本",
            prop: "version",
            width:"90"
        },
        {
            label: "状态",
            prop: "status",
            width:"100"
        },
        {
            label: "创建时间",
            prop: "create_datetime",
            minWidth:"180"
        }
    ])

    let isWorkflowDialogVisible = ref(false)
    let moduleWorkflowFlag = ref(null)
    function handleAddClick(){
        isWorkflowDialogVisible.value = true
        nextTick(()=>{
            moduleWorkflowFlag.value.handleOpen(null,"新建流程")
        })
    }

    function changeStatus(row) {
        //避免:active-value="1" :inactive-value="0"在初始化时触发 change 事件
        if (isInitializing.value) {
            return
        }
        let flat = row.status
        row.status = row.status == 1?row.status=0:row.status=1
        ElMessageBox.confirm('确定修改状态吗？', '提醒', {
            closeOnClickModal: false,
            type:"warning"
        }).then(ret => {
            Api.lyworkflowOpstatus({ id: row.id }).then(res => {
                if (res.code == 2000) {
                    flat == 1 ? row.status = 0 : row.status = 1
                    ElMessage.success(res.msg)
                    getData()
                } else {
                    ElMessage.warning(res.msg)
                }
            })
        }).catch(() => {

        })
    }

    function handleEdit(row,flag){
        if(flag=='edit') {
            isWorkflowDialogVisible.value = true
            nextTick(()=>{
                moduleWorkflowFlag.value.handleOpen(row,"编辑流程")
            })
        }
        else if(flag=='delete') {
            ElMessageBox.confirm('您确定要删除选中的数据吗？',"警告",{
                closeOnClickModal:false,
                type:"warning"
            }).then(ret=>{
                Api.lyworkflowDelete({id:row.id}).then(res=>{
                    if(res.code == 2000) {
                        ElMessage.success(res.msg)
                        search()
                    } else {
                        ElMessage.warning(res.msg)
                    }
                })
            }).catch(()=>{

            })
        }
        else if(flag=="reset"){
            formInline.value = {}
            search()
        }
    }
    
    // 计算搜索栏的高度
    function listenResize() {
        nextTick(() => {
            getTheTableHeight()
        })
    }
    function getTheTableHeight(){
        let tabSelectHeight = tableSelect.value?tableSelect.value.offsetHeight:0
        tabSelectHeight = isFull.value?tabSelectHeight - 110:tabSelectHeight
        tableHeight.value =  getTableHeight(tabSelectHeight,false) - 125
    }

    let tableref = ref(null)
    function search() {
        tableref.value.reload(formInline.value)
    }
    //获取列表
    async function getData() {
        tableref.value.getData()
    }

    let isFull = ref(false)
    function setFull(){
        isFull.value=!isFull.value
        window.dispatchEvent(new Event('resize'))
    }

    defineExpose({
        setFull
    })

    onMounted(() => {
        // 监听页面宽度变化搜索框的高度
        window.addEventListener('resize', listenResize);
        nextTick(() => {
            getTheTableHeight()
        })
        setTimeout(() => {
            isInitializing.value = false
        }, 100); // 适当调整延迟时间，以确保初始化完成后再取消标志位
    })
    onUnmounted(() => {
        // 页面销毁，去掉监听事件
        window.removeEventListener("resize", listenResize);
    })
</script>